'use client';

import { c as _c } from "react/compiler-runtime";
import { type PropsWithChildren } from 'react';
import { type AnalyticsEvents } from '@src/hooks/useClickAction/useClickAction.builder';
import { ActionLink } from '../ActionLink/ActionLink';
interface CdpTileProps extends PropsWithChildren {
  title: string;
  description: string;
  featureTags: Array<{
    value: string;
  }>;
  price: string;
  promotionalPrice?: string;
  href?: string;
  target?: '_self' | '_blank';
  analyticsEvent?: (typeof AnalyticsEvents)[number];
  analyticsModule?: string;
}
export const CdpTile = t0 => {
  const $ = _c(31);
  const {
    children,
    title,
    description,
    featureTags,
    price,
    promotionalPrice,
    href,
    target,
    analyticsEvent,
    analyticsModule
  } = t0;
  let t1;
  if ($[0] !== analyticsEvent || $[1] !== href || $[2] !== target) {
    t1 = {
      href,
      target,
      analyticsEvent
    };
    $[0] = analyticsEvent;
    $[1] = href;
    $[2] = target;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children) {
    t2 = <div className="relative h-[220px] w-full overflow-hidden rounded-t-[32px] [&_div]:size-full [&_img]:h-full [&_img]:w-auto [&_img]:max-w-none">{children}</div>;
    $[4] = children;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== title) {
    t3 = <h2 className="text-body-lg font-medium">{title}</h2>;
    $[6] = title;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== description) {
    t4 = <p className="text-body-sm">{description}</p>;
    $[8] = description;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t3 || $[11] !== t4) {
    t5 = <div className="flex flex-col gap-2">{t3}{t4}</div>;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== featureTags) {
    t6 = featureTags?.map(_temp);
    $[13] = featureTags;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t6) {
    t7 = <div className="flex flex-row flex-wrap gap-2">{t6}</div>;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== price || $[18] !== promotionalPrice) {
    t8 = <div className="text-heading-4 mt-auto flex flex-row items-start gap-2">{promotionalPrice ? <><div className="text-bodi-gray-medium"><s>{price}</s></div><div>{promotionalPrice}</div></> : <div>{price}</div>}</div>;
    $[17] = price;
    $[18] = promotionalPrice;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t5 || $[21] !== t7 || $[22] !== t8) {
    t9 = <div className="flex flex-1 flex-col gap-3 px-4">{t5}{t7}{t8}</div>;
    $[20] = t5;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t2 || $[25] !== t9) {
    t10 = <div className="flex h-full w-[330px] flex-col gap-4 rounded-3xl bg-white pb-4 transition-all hover:drop-shadow-md lg:rounded-[32px]">{t2}{t9}</div>;
    $[24] = t2;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== analyticsModule || $[28] !== t1 || $[29] !== t10) {
    t11 = <ActionLink analyticsModule={analyticsModule} actionName="navigate" navigate={t1} className="h-full *:h-full *:rounded-[32px]">{t10}</ActionLink>;
    $[27] = analyticsModule;
    $[28] = t1;
    $[29] = t10;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  return t11;
};
function _temp(tag, idx) {
  return <div key={idx} className="flex h-7 items-center rounded-full bg-bodi-gray-pearl px-3 text-body-sm whitespace-nowrap">{tag.value}</div>;
}